import { render, staticRenderFns } from "./PagBankConnectDialog.vue?vue&type=template&id=07b222d8"
import script from "./PagBankConnectDialog.vue?vue&type=script&lang=ts"
export * from "./PagBankConnectDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports